import {Values} from "@reside/forms";
import {useQuery} from "react-query";
import Alert from "react-s-alert";

import {Resident} from "../../page-admin-residents/types";
import {ResidentService} from "../../../services/ResidentServices";
import {residentToPreflightAnswers} from "../utils/helpers/helpers";

export type PreflightResidentPrefill = Readonly<{
  prefill: Values;
  resident: Resident;
}>;

export const preflightResidentPrefillQueryKey = (residentId?: string) =>
  ["preflightResidentPrefill", residentId] as const;

/**
 * Loads resident demographics to pre-fill a new preflight when started from Start Workflow.
 */
export const usePreflightResidentPrefill = ({
  residentId,
  enabled = true,
}: {
  residentId?: string;
  enabled?: boolean;
}) =>
  useQuery(
    preflightResidentPrefillQueryKey(residentId),
    async (): Promise<PreflightResidentPrefill> => {
      const {data: resident} = await ResidentService.getOneResident(residentId!);
      return {
        prefill: residentToPreflightAnswers(resident),
        resident,
      };
    },
    {
      enabled: enabled && Boolean(residentId),
      onError: () =>
        Alert.error(
          "Failed to load resident details for pre-flight. Please, try again later.",
        ),
    },
  );
